const message = {
  header: {
    site: 'в партнёрстве с',
    title: 'Угадывай счет, выигрывай подарки и',
    shortDescription: `Здесь собираются все настоящие фанаты футбола.
     Те, кто правильно угадают счет 64 матчей в рамках Чемпионата Мира по Футболу 2022,
      получат множество классных призов: телевизоры, Microsoft Xbox Series S, кофемашины и полезную технику для дома...`,
    description: `Здесь собираются все настоящие фанаты футбола.
     Те, кто правильно угадают счет 64 матчей в рамках Чемпионата Мира по Футболу 2022,
      получат множество классных призов: телевизоры, Microsoft Xbox Series S, кофемашины и полезную технику для дома.
      Помимо этих призов, после каждого правильного прогноза матча, ты можешь выиграть ценные бонусы – eЛеи.
       <br /><br />
       Итак, что же нужно сделать для участия? Всё очень просто. Смотри матчи, угадывай счет, набирай очки, <br />
        будь на первом месте в таблице ➡ и выигрывай крутые призы и бонусы «eЛеи».`,
    more: 'подробности',
    less: 'скрыть'
  },
  navbar: {
    predict: 'Прогнозы',
    rules: 'Условия',
    list: 'Турнирная таблица',
    gifts: 'Призы',
    menu: 'Меню',
    notify: 'Получать уведомления',
    chat: 'Чат'
  },
  hack: {
    warning: 'Внимание!',
    tooLong: 'Вы ввели слишком длинное значение!'
  },
  account: {
    points: 'баллы',
    logout: 'выйти'
  },
  auth: {
    auth: 'Авторизация',
    mail: 'Емайл',
    pass: 'Пароль',
    repass: 'Пароль еще раз',
    login: 'Войти',
    orWith: 'Или с помощью:',
    notAuth: 'Нет учетной записи ?',
    reg: 'Регистрация',
    required: 'Это обязательное поле',
    name: 'Имя',
    surname: 'Фамилия',
    birthDate: 'День рождения',
    phone: 'Телефон',
    confirm: 'Подтвердить',
    datePicker: 'ru-Latn',
    warning: 'Внимание!',
    field_required: 'Для того чтобы продолжить вы должны заполнить все поля.',
    password_math: 'Ваши пароли не совпадают.',
    error: 'Ошибка!',
    auth_fail: 'Авторизация не прошла.',
    auth_to_save: 'Чтобы сохранить ваши данные вы должны авторизоватся.',
    recovery: 'Забыли пароль?',
    recover: 'Восстановить',
    recoveryTitle: `Востановление пароля`,
    recoveryText: `Для того чтобы сбросить ваш пароль вы должны вести <b>email</b> и <b>номер телефона</b> которые вы ввели при регистарции.`,
    agreeText: `Я прочитал <a href="/static/document/regulament.pdf" target="_blank">регламент</a>`
  },
  pages: {
    predict: 'Прогнозы матчей',
    rules: 'Правила',
    gifts: 'Призы',
    rank: 'Рейтинг участников'
  },
  footer: {
    contact: 'Есть вопросы? Звоните:'
  },
  gift: {
    place: 'место',
    tv: 'Телевизор',
    shoes: 'Умные кроссовки',
    handsfree: 'Беспроводные наушники',
    smartband: 'Фитнес браслет',
    ball: 'Футбольный мяч',
    bag: 'Рюкзак',
    footer: {
      title: '',
      text: ``
    }
  },
  rules: {
    list: [
      {
        title: 'Как и когда можно принять участие в конкурсе?',
        description: `Участвовать в нашем конкурсе невероятно просто! 
        Всё что тебе нужно – это активная учётная запись в Facebook или Google. 
        Если у тебя нет ни того ни другого, ты можешь зарегистрироваться вручную на нашей платформе. 
        Принять участие в акции можно в период с 20 ноября по 18 декабря 2022 года (период проведения ЧМ-2022).`
      },
      {
        title: 'Что делать?',
        description: `
        Механика конкурса очень проста. <br>
        1. После регистрации на платформе ты автоматически считаешься участником конкурса.<br>
        2. Тебе нужно предсказать результат  64 матчей, сыгранных на чемпионате мира по футболу 2022 года.<br>
        3. Угадывай результаты и накапливай баллы:<br>
        <br>
        • Если ты угадываешь команду, победившую в игре, ты получаешь 1 балл;<br>
        • Если ты угадываешь финальный счет игры, ты получаешь 3 балла;<br>
        • Если ты не угадал ни победителя ни итоговый счёт, то ты не получаешь баллов.<br>
        • Незавершенные матчи будет считаться за пропущенный ответ, ты не получаешь баллов.<br>`
      },
      {
        title: 'Как мне победить?',
        description: `
        Тебя ждут множество крутых и ценных призов! 
        В том числе и eLei, которые, можно выиграть сразу после каждого матча. 
        Окончательный рейтинг будет составлен по количеству баллов, набранных участниками, в порядке убывания. 
        Естественно, самый крутой приз получит тот, кто наберёт наибольшее количество баллов.`
      }
    ],
    download: 'Cкачать подробный регламент'
  },
  rank: 'Страница находится на стадии обновления...',
  game: {
    start: 'Матч начался',
    finish: 'Матч окончен',
    enterPredict: 'Введите прогноз',
    gotPredict: `Ваш прогноз принят <br> Желаем вам удачи!`,
    toolate: `Вы не успели <br> сделать прогноз!`,
    needAuth: 'Нужна авторизация',
    winner: 'Поздравляем!',
    got: 'Вы получили',
    points: 'балла',
    point: 'балл',
    noPoints: 'баллов',
    yourScore: 'Ваш прогноз'
  },
  champions: {
    login: 'Авторизуйтесь чтобы увидеть свой результат.',
    place: 'МЕСТО',
    user: 'УЧАСТНИК',
    points: 'БАЛЛЫ',
    denied: 'Участник был дисквалифицирован',
    youDenied: 'К сожалению вы были дисквалифицированы'
  },
  banners: {
    btn: 'Выбрать'
  },
  dialog: {
    title: 'Не пропусти<br>ни один матч',
    text: 'Следи за последними новостями <br> и обсуждай итоги матчей'
  }
}

export default message



// WEBPACK FOOTER //
// ./src/lang/ru.js